module.exports = __webpack_public_path__ + "d9a7ca3035a2f3d2870477b1ffd9830d.png";